import React from 'react';
import ChildrenMentoring from '../components/ChildrenMentoring';

const ChildrenMentoringPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <ChildrenMentoring />
    </div>
  );
};

export default ChildrenMentoringPage;